import { getComparableOfferPrice } from '../components/PriceComparison/simpleProductPageShared';

function amount(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

/** A retailer list price identifies a sale; manufacturer references identify savings. */
export function getOfferSavings(offer, manufacturerPrice = null, referenceLabel = 'MSRP') {
  const price = getComparableOfferPrice(offer);
  if (price == null) return null;
  const retailerRegular = amount(offer?.list_price);
  const standard = amount(manufacturerPrice);
  const onSale = retailerRegular != null && Math.round(retailerRegular * 100) > Math.round(price * 100);
  const reference = onSale ? retailerRegular : standard;
  if (reference == null || Math.round(reference * 100) <= Math.round(price * 100)) return null;
  const saved = Math.round((reference - price) * 100) / 100;
  const percent = Math.round((reference - price) / reference * 100);
  if (saved < 1 && percent === 0) return null;
  return {
    onSale,
    referencePrice: reference,
    referenceLabel: onSale ? 'retailer regular price' : referenceLabel,
    amount: saved,
    percent,
  };
}
